import { Circle } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

import { InferPropTypes } from '../../types';

const sizes = {
  md: '8px',
  lg: '12px'
};
const colorMap = {
  black: 'black.base',
  grey: 'grey.base',
  silver: 'silver.base',
  blue: 'blue.base',
  green: 'green.base',
  red: 'red.base',
  gold: 'gold.base'
};

export type IndicatorProps = InferPropTypes<typeof propTypes, typeof defaultProps>;
export default function Indicator(props: IndicatorProps): React.ReactElement {
  const { size, color, ...rest } = props;
  const calculatedSize = sizes[size] || 'md';
  const background = colorMap[color] || 'blue.base';
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  /* @ts-ignore */
  return <Circle bg={background} h={calculatedSize} w={calculatedSize} {...rest} />;
}

export const colorPropTypes = ['black', 'grey', 'silver', 'blue', 'green', 'red', 'gold'];
export const sizePropTypes = ['md', 'lg'];

const propTypes = {
  color: PropTypes.oneOf(colorPropTypes),
  size: PropTypes.oneOf(sizePropTypes)
};

const defaultProps = {
  color: 'blue',
  size: 'md'
};

Indicator.propTypes = propTypes;
Indicator.defaultProps = defaultProps;
